import React from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js";
import { Box, Typography } from "@mui/material";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

export default function SalesPerDayMonthGraph({ data }) {
  const labels = data.map((item) => item.day);
  const totals = data.map((item) => item.daily_total);

  const charData = {
    labels,
    datasets: [
      {
        label: "Total Facturado por Día",
        data: totals,
        backgroundColor: "#2d8bba",
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            const index = context.dataIndex;
            const total = data[index]?.daily_total ?? 0;
            const count = data[index]?.sales_count ?? 0;
            return [
              `Total facturado: $${total}`,
              `Cantidad de ventas: ${count}`,
            ];
          },
        },
      },
    },
    scales: {
      x: {
        title: {
          display: true,
          text: "Días del Mes",
        },
        ticks: {
          autoSkip: false,
          maxRotation: 0,        
          minRotation: 0,
          font: {
            size: 12,
          },
        },
      },
      y: {
        title: {
          display: true,
          text: "Total Facturado ($)",
        },
        beginAtZero: true,
      },
    },
  };

  return (
    <Box sx={{ height: "70%", width: "100%"}}>
      <Typography variant="h6" mb={0}>
        Facturación Mensual por Día
      </Typography>
      <Bar data={charData} options={options} />
    </Box>
  );
}
